import axios from 'axios';
import { config } from '../../config';

const get_access_authorities = (options = {}) => {
    const includeMembers = options.includeMembers !== false;

    return axios.get(`${config.backendUrl}/access/authorities`, {
        params: {
            includeMembers
        }
    });
};

const get_access_company = () => {
    return axios.get(`${config.backendUrl}/access/company`);
};

const evaluate_access = (payload = {}) => {
    return axios.post(`${config.backendUrl}/access/evaluate`, payload);
};

export {
    get_access_authorities,
    get_access_company,
    evaluate_access
};
